import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import type { ListMeetingsQuery, MeetingResponse } from '@orion/contracts';
import { api } from '../../lib/api-client.js';

function toQueryString(query: ListMeetingsQuery): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined && value !== '') params.set(key, String(value));
  }
  return `?${params.toString()}`;
}

export function useMeetingsQuery(query: ListMeetingsQuery) {
  return useQuery({
    queryKey: ['meetings', query],
    queryFn: () => api.get<MeetingResponse[]>(`/meetings${toQueryString(query)}`),
  });
}

/** The manual counterpart to automatic lead/contact matching — for a
 * meeting whose invitee wasn't already a Lead or Contact (so it's on the
 * calendar but otherwise unlinked), turns it into a new Lead. */
export function useCreateLeadFromMeeting() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (meetingId: string) => api.post<MeetingResponse>(`/meetings/${meetingId}/create-lead`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['meetings'] }),
  });
}
